import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

const Circle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: -24,
  left: -24,
  borderRadius: "100%",
  width: "48px",
  height: "48px",
  backgroundColor: "#6E8CFC",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    left: "calc(50% - 24px)",
  },
}));

export const StepCircle = (props: { number: string }) => {
  return (
    <Circle>
      <Typography variant="h5" component="span" sx={{ color: "#fff" }}>
        {props.number}
      </Typography>
    </Circle>
  );
};
